class NotFoundError extends Error {

    constructor(message) {
        super(message)
        this.name = 'NotFoundError'
        this.message = message || 'Entity not found'
        this.stack = (new Error()).stack
    }
}

export default NotFoundError
